// Technical coordinates strip — appears just before the footer.
export const Coordinates = () => (
  <div
    data-testid="coordinates-strip"
    className="bg-white border-t-2 border-black"
  >
    <div className="px-6 md:px-12 lg:px-20 py-6 flex items-center justify-between font-mono text-[11px] tracking-[0.25em] uppercase text-black/70 flex-wrap gap-3">
      <span>N 35.8436° · W 78.6111°</span>
      <span className="hidden sm:inline">Est / MMXXI</span>
      <span>Raleigh / NC</span>
    </div>
  </div>
);

export default Coordinates;
